export default __webpack_public_path__ + "c3e5ba95e76fc6bae31199a53dbde6bb.jpg";